import { FC, useEffect, useState } from "react";
import * as M from "moment";

import styles from "./DateTime.module.scss";

const DateTimeInformer: FC = (props) => {
  const [dateTime, setDateTime] = useState({ time: null, date: null}); 

  useEffect(() => {
    const timer = setInterval(() => {
      const dateObject = new Date();

      const date = M(dateObject).format("HH:mm");
      const time = M(dateObject).format("DD.MM.YYYY");

      setDateTime({
        time: time,
        date: date,
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={styles.Clock}>
      {dateTime.time && <span>{dateTime.time}</span>}
      {dateTime.date && <span>{dateTime.date}</span>}
    </div>
  );
};

export default DateTimeInformer;
